import replaceCharBy from 'src/utils/strings/replaceCharBy';

/**
 * Encrypts string characters with *
 * @param {string} characters to hide
 * @returns string
 */
const encryptCharsWithStars = (characters: string): string => replaceCharBy(characters, '*');

export default encryptCharsWithStars;